<div class="modal-lg">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Asignar</h4>
    <button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.close()">
      <i class="fas fa-times-circle"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 pb-4 pl-4 pr-4 pt-0">
      <div class="col-md-12">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-5 col-form-label" style="padding-left: inherit">Selecciona Usuario:
            <span class="text-danger">&#10033;</span>
          </label>
          <div class="col-sm-7">
            <select (change)="onValueUserChange($event.target.value)" class="form-control" data-cy="select-simple">
              <option value="" >Seleccionar</option>
              @for (value of users; track value) {
                <option [value]="value.id">
                  {{ value.name }} - {{ "(" }}{{ value.email }} {{ ")" }} {{ value.profilename? '- ( Perfil: '+value.profilename+' )' :'' }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="
          btn btn-outline-primary
          bg-white
          rounded-pill
          text-dark
          px-4
          font-weight-bold
        " (click)="activeModal.dismiss('Cross click')">
      Cancelar
    </button>
    <button type="button" class="
          btn btn-outline-primary
          bg-white
          rounded-pill
          text-dark
          px-4
          font-weight-bold
        "  (click)="!isSubmitting && saveDataToChangeStatus()" [disabled]="!isValidate || isSubmitting" data-cy="submit">
      {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
    </button>
  </div>
</div>
